import React from 'react';

import classNames from 'classnames';
import styles from './styles.module.css';
import { Feature } from './types';

const generateDataTestId = (label: string) =>
  `fee-line-${label.toLowerCase().replace(/\s+/g, '-')}`;

export type FeatureLineProps = {
  feature: Feature;
};

function featureStyles(enabled: boolean) {
  return enabled ? styles.enabledFeature : styles.disabledFeature;
}

export const FeatureLine: React.FC<FeatureLineProps> = ({ feature }) => (
  <div
    data-testid={generateDataTestId(feature.identifier)}
    className={styles.feeLineContainer}
  >
    <span className={styles.feeLineLabel}>{feature.identifier}</span>

    <span className={styles.feeLineValueContainer}>
      <span
        className={classNames(
          styles.feeLineValue,
          featureStyles(feature.enabled)
        )}
      >
        {feature.enabled ? 'Included' : 'Not Included'}
      </span>
    </span>
  </div>
);
